import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const mapPinRed = require('@qfa/react-components/lib/components/images/mapPinRed.png');

export const useMapStyles = makeStyles(() => {
  return createStyles({
    fullHeight: {
      height: '100%',
    },
    mapPinActive: {
      '& > div > div > div > #view-MapView': {
        cursor: `url(${mapPinRed}) 14 32, auto !important`,
      },
    },
  });
});
